import { TLeaguesSlug } from './types';
import { bronzeSlugs, ironSlugs, silverSlugs } from '@entities/jackpot';

const IMAGES_PATH = '/images/jackpotBig/';
const LAST_CHECK_KEY = 'jackpotLastCheckAt';

export const getJackpotImagePathBySlug = (slug: TLeaguesSlug): string | undefined => {
  if (ironSlugs.includes(slug)) return IMAGES_PATH + 'Iron.svg';
  if (bronzeSlugs.includes(slug)) return IMAGES_PATH + 'Bronze.svg';
  if (silverSlugs.includes(slug)) return IMAGES_PATH + 'Silver.svg';
  return undefined;
};

export const getLastJackpotCheckAt = (): number => {
  const raw = localStorage.getItem(LAST_CHECK_KEY);
  return raw ? parseInt(raw, 10) : 0;
};

export const setLastJackpotCheckAt = (ts: number) => {
  localStorage.setItem(LAST_CHECK_KEY, ts.toString());
};
